exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-box[data-v-4ede72e2]{min-height:calc(100vh - 77px)}.list-header[data-v-4ede72e2]{padding:0}.table-box[data-v-4ede72e2] .el-table th{background-color:#f7fbff}\n", ""]);

// exports
